import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface ConsultaLicencaOrganizacaoExclusaoProps {
    show: boolean;
    onHide: () => void;
    idItemLicencaOrganizacao: string;
    idItensLicencaOrganizacao: number;
    itensLicencaOrganizacao: [{ [key: string]: string; }];
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
    setItensLicencaOrganizacao: (itensLicenca: [{ [key: string]: string; }]) => void;
}

function ConsultaLicencaOrganizacaoExclusao(props: ConsultaLicencaOrganizacaoExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoLicencaOrganizacao, setCarregandoLicencaOrganizacao] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoLicencaOrganizacao(true);
            api.get(`/ItemLicenca/${props.idItemLicencaOrganizacao}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoLicencaOrganizacao(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoLicencaOrganizacao(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        let itens: [{ [key: string]: string; }] = [{}];

        for (let contador = 0; contador < props.itensLicencaOrganizacao.length; contador++) {
            if (String(props.itensLicencaOrganizacao[contador].id) !== String(props.idItensLicencaOrganizacao)) {
                (itens[0].id === undefined)
                    ? itens[0] = props.itensLicencaOrganizacao[contador]
                    : itens.push(props.itensLicencaOrganizacao[contador]);
            }
        };

        props.setItensLicencaOrganizacao(itens);
        informarSucesso();
    }

    function informarSucesso() {
        props.onHide();
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoLicencaOrganizacao
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir o item ${nome}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default ConsultaLicencaOrganizacaoExclusao;